import { render } from "./DesignPage.vue?vue&type=template&id=3308bc9e&scoped=true"
import script from "./DesignPage.vue?vue&type=script&lang=ts"
export * from "./DesignPage.vue?vue&type=script&lang=ts"

import "./DesignPage.vue?vue&type=style&index=0&id=3308bc9e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3308bc9e"

export default script